<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IougCY/tc-custom/9781788634380.jpg?1721442313871" alt="This image is the cover for the book Soul Thief, The Life and Times of Corban Loosestrife"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Soul Thief, The Life and Times of Corban Loosestrife
      </h1>
      <p class="bookDescription body article font2">
        <p>  <b>A Viking raid leads a young man on a quest to save his sister in this “potent blend of fantasy, history, and romance . . . Rich with Nordic lore” (<i>Publishers Weekly</i>).</b><br/>  <br/> Though Corban and Mav are twins, they could not be more different in the eyes of their father, the lord of an Irish coastal farmstead. While Mav has the Second Sight and is her father's favorite, Corban is a deep disappointment. Exiled for refusing to take up his sword in the name of the High King, he is long gone when Viking dragon ships bring slaughter to his people and fire to his home.<br/><br/> Now Corban must embark on an epic quest to save his sister from slavery. From the far coast of Ireland to the occupied village of Dublin, and across the sea to the Kingdom of the Danes, Corban is drawn to the trail of his sister, fighting for his life and striving to earn the influence and money he will need to buy her freedom. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cecelia Holland
      </h2>
      
      <p class="authorDescription body article">Cecelia Holland was born in Henderson, Nevada, in 1943 and started writing at the age of twelve. Starting with&#160;<I>The Firedrake&#160;</I>in 1966, she has published twenty-one independent historical novels covering periods from the middle of the first millennium CE up through parts of the early twentieth century, and from Egypt, through Russia, central Europe, Scandinavia, Great Britain, and Ireland to the West Coast of the United States. Most recently, she has completed a series of five novels set in the world of the Vikings, covering a period of about fifty years during the tenth century and following the adventures of Corban Loosestrife and his descendants. The hallmark of her style is a vivid re-creation of time, place, and character, all true to known facts. She is highly regarded for her attention to detail, her insight into the characters she has researched and portrayed, and her battle scenes, which are vividly rendered and powerfully described. Holland has also published two nonfiction historical/biographic works, two children&rsquo;s novels, a contemporary novel, and a science fiction novel, as well as a number of historical essays.<BR />&#160;Holland has three daughters. She lives in Fortuna, California, and, once a week, teaches a class in creative writing at Pelican Bay State Prison in Crescent City, California. Holland&#39;s personal website is www.thefiredrake.com.&#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?98e312ca